// Where config.ts finds rcobchod's host elements and product ids.

import type { Ga4EventData } from "@raventic/sdk";

// The dropdown's `activateOn`, one selector per header search (the search SDK binds only the FIRST match
// of a selector). The SDK picks its version from the element: on an <input> it attaches below that box
// (no input of its own), on anything else it opens with its own input.
// - Desktop (≥992px): the real search box, `#frm-searchForm input`.
// - Mobile (<992px): `#frm-searchForm-mobil` is a 42px circle, an <input> styled as a magnifier icon
//   (`.search-circle-input` + `.search-circle-icon`), not a box to type in. Bound on its wrapper <div>,
//   so the dropdown opens with its own input, as the site's own search does there.
// Both inputs still carry Luigi's Box's `lbx-searchbox` hook.
export const SEARCH_INPUT_SELECTORS = ['#frm-searchForm input[name="sWord"]', "#frm-searchForm-mobil .search-circle-wrapper"];

// The search page (`/vyhledavani/?sWord=…`): the forms' action and query parameter.
export const SEARCH_PATH = "/vyhledavani/";
export const SEARCH_QUERY_PARAMETER = "sWord";

// Product detail: rcobchod pushes GA4 `view_item` on every product page, before widget.js runs,
// `{ event: "view_item", ecommerce: { items: [{ item_id: "316558", … }] } }` — `item_id` is the
// shop id, which is our product id. Read from the ga4Event trigger data (config.ts).
export const viewItemProductId = (trigger: unknown): string => {
  const id = (trigger as Ga4EventData | null | undefined)?.ecommerce?.items?.[0]?.item_id;
  return typeof id === "string" || typeof id === "number" ? String(id).trim() : "";
};
